import { useState } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CoreValueSection from './components/CoreValueSection';
import LegalServicesSection from './components/LegalServicesSection';
import ConsultingSection from './components/ConsultingSection';
import DisasterPreventionSection from './components/DisasterPreventionSection';
import PerformanceSection from './components/PerformanceSection';
import ResourcesSection from './components/ResourcesSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <CoreValueSection />
      <LegalServicesSection />
      <ConsultingSection />
      <DisasterPreventionSection />
      <PerformanceSection />
      <ResourcesSection />
      <Footer />
    </div>
  );
}